import React from "react";
import ProductName from "brand-customization/ProductName";
export const TIME_UNITS = ["hours", "days", "months", "years"];
export const TIME_UNITS_UPPER = TIME_UNITS.map((unit) => unit.toLocaleUpperCase());
export const MIGRATION_STEP = {
  CA_CONFIGURATION: {
    key: "CA_CONFIGURATION",
    description: "Configure a certificate authority"
  },
  RENEWAL_POLICY_CONFIGURATION: {
    key: "RENEWAL_POLICY_CONFIGURATION",
    description: "Configure a renewal policy"
  },
  COMPATIBILITY_CHECK: {
    key: "COMPATIBILITY_CHECK",
    description: "Check OpenSearch compatibility with datanode"
  },
  MANUAL_MIGRATION_STEP: {
    key: "MANUAL_MIGRATION_STEP",
    description: "Migration steps."
  },
  MIGRATION_FINISHED: {
    key: "MIGRATION_FINISHED",
    description: "Migration finished"
  }
};
export const MIGRATION_STATE = {
  NEW: {
    key: "NEW",
    description: "Migration"
  },
  MIGRATION_WELCOME_PAGE: {
    key: "MIGRATION_WELCOME_PAGE",
    description: "Welcome"
  },
  CA_CREATION_PAGE: {
    key: "CA_CREATION_PAGE",
    description: "Certificate authority"
  },
  RENEWAL_POLICY_CREATION_PAGE: {
    key: "RENEWAL_POLICY_CREATION_PAGE",
    description: "Certificate renewal policy"
  },
  MIGRATION_SELECTION_PAGE: {
    key: "MIGRATION_SELECTION_PAGE",
    description: "Migration steps"
  },
  ROLLING_UPGRADE_MIGRATION_WELCOME_PAGE: {
    key: "ROLLING_UPGRADE_MIGRATION_WELCOME_PAGE",
    description: "Welcome to In-Place migration"
  },
  ASK_TO_SHUTDOWN_OLD_CLUSTER: {
    key: "ASK_TO_SHUTDOWN_OLD_CLUSTER",
    description: "Shut down old cluster"
  },
  MANUALLY_REMOVE_OLD_CONNECTION_STRING_FROM_CONFIG: {
    key: "MANUALLY_REMOVE_OLD_CONNECTION_STRING_FROM_CONFIG",
    description: "Remove connection string"
  },
  MESSAGE_PROCESSING_STOP: {
    key: "MESSAGE_PROCESSING_STOP",
    description: "Stop message processing"
  },
  REPLACE_CLUSTER: {
    key: "REPLACE_CLUSTER",
    description: "Replace existing cluster"
  },
  RESTART_GRAYLOG: {
    key: "RESTART_GRAYLOG",
    description: /* @__PURE__ */ React.createElement(React.Fragment, null, "Update configuration file and restart ", /* @__PURE__ */ React.createElement(ProductName, null))
  },
  DIRECTORY_COMPATIBILITY_CHECK_PAGE: {
    key: "DIRECTORY_COMPATIBILITY_CHECK_PAGE",
    description: "Directory compatibility check"
  },
  PROVISION_ROLLING_UPGRADE_NODES_WITH_CERTIFICATES: {
    key: "PROVISION_ROLLING_UPGRADE_NODES_WITH_CERTIFICATES",
    description: "Certificate provisioning overview"
  },
  PROVISION_ROLLING_UPGRADE_NODES_RUNNING: {
    key: "PROVISION_ROLLING_UPGRADE_NODES_RUNNING",
    description: "Provision the Data Node's certificate."
  },
  JOURNAL_SIZE_DOWNTIME_WARNING: {
    key: "JOURNAL_SIZE_DOWNTIME_WARNING",
    description: "Journal size downtime warning"
  },
  FAILED: {
    key: "FAILED",
    description: "Migration failed"
  },
  FINISHED: {
    key: "FINISHED",
    description: "Migration finished"
  }
};
export const IN_PLACE_MIGRATION_STEPS = [
  MIGRATION_STATE.ROLLING_UPGRADE_MIGRATION_WELCOME_PAGE.key,
  MIGRATION_STATE.DIRECTORY_COMPATIBILITY_CHECK_PAGE.key,
  MIGRATION_STATE.PROVISION_ROLLING_UPGRADE_NODES_RUNNING.key,
  MIGRATION_STATE.JOURNAL_SIZE_DOWNTIME_WARNING.key,
  MIGRATION_STATE.MESSAGE_PROCESSING_STOP.key,
  MIGRATION_STATE.RESTART_GRAYLOG.key
];
export const MIGRATION_WIZARD_STEPS = [
  MIGRATION_STATE.NEW.key,
  MIGRATION_STATE.MIGRATION_WELCOME_PAGE.key,
  MIGRATION_STATE.CA_CREATION_PAGE.key,
  MIGRATION_STATE.RENEWAL_POLICY_CREATION_PAGE.key,
  MIGRATION_STATE.MIGRATION_SELECTION_PAGE.key,
  MIGRATION_STATE.FINISHED.key
];
export const MIGRATION_ACTIONS = {
  SHOW_RENEWAL_POLICY_CREATION: {
    key: "SHOW_RENEWAL_POLICY_CREATION",
    label: "Configure certificate renewal policy"
  },
  SHOW_MIGRATION_SELECTION: {
    key: "SHOW_MIGRATION_SELECTION",
    label: "Go to migration steps"
  },
  RUN_DIRECTORY_COMPATIBILITY_CHECK: {
    key: "INSTALL_DATANODES_ON_EVERY_NODE",
    label: "Run directory compatibilty check"
  },
  PROVISION_DATANODE_CERTIFICATES: {
    key: "PROVISION_DATANODE_CERTIFICATES",
    label: "Provision Data Nodes with certificates"
  }
};
export default MIGRATION_STEP;
